import * as util from './other/util.js';
import config from './config.js';

export const DEPLOY = config.deploy;
const IP = config.host;
const PORT = config.port;
const PROTOCOL = config.protocol;

function buildDebugUri(endpoint, param = "") {
    return PROTOCOL + "://" + IP + ((PORT > 0 ? ":" + PORT : "")) + "/debug/" + endpoint + ((param === "") ? "" : "/" + param);
}

function buildRestUri(endpoint, param = "") {
    return PROTOCOL + "://" + IP + ((PORT > 0 ? ":" + PORT : "")) + "/rest/" + endpoint + ((param === "") ? "" : "/" + param);
}

if (config.logging) {
    console.log("DEPLOY: " + DEPLOY);
    console.log("REST API: " + buildRestUri("endpoint"));
}

export var changeDisplayedPage = { callback: null };

// Documentation for fetch API
// https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch

function doRequest(method, url, data, next) {
    return fetch(url, {
        method: method, // *GET, POST, PUT, DELETE, etc.
        mode: (DEPLOY ? "same-origin" : "cors"), // no-cors, cors, *same-origin
        credentials: "include", // include, *same-origin, omit
        body: JSON.stringify(data), // body data type must match "Content-Type" header
        headers: {
            "Content-Type": "application/json",
        },
    }).then((response) => {
        // Allow ok and teapots!
        // We do not use status codes to indicate in-game errors, but a json object:
        // {success: true|false, error: "description"}
        if (response.status === 200 || response.status === 418) {
            return response.json();
        }

        // Give out some nicer error messages for known errors
        if (response.status === 401) {
            throw new Error('Session expired, not logged in!');
        }
        throw new Error('Bad status code from server: ' + response.status);
    }).then((myJson) => {
        if (myJson.gps) {
            console.log("Got gps update");
            util.updateGps(myJson.gps);
        }
        return next(myJson);
    }).catch((err) => {
        if (!err) {
            err = "Unknown error.";
        }
        console.log("Error: " + err.message);
        if (!changeDisplayedPage.callback) {
            console.warn("changeDisplayedPage.callback not this. That only happens if this code here is running before react is setup. That should only happen if auto login fails.");
        } else {
            if (err.message === "Failed to fetch") {
                changeDisplayedPage.callback("Can not reach server!"); // This might just be a server crash
            } else {
                changeDisplayedPage.callback(err.message);
            }
        }

        // Throw again for good measure: this way we see the stack trace in the log
        if (config.debug) {
            throw err;
        }
    });
}

export function getDashboardInfo(next) {
    doRequest("GET", buildRestUri("player-dashboard"), undefined, (res) => {
        next(res);
    });
}

export function tryPlayerDetailUpdate(faction, faction_description, next) {
    doRequest("POST", buildRestUri("player/update-details"), {
        faction: faction,
        faction_description: faction_description,
    }, next);
}

export function getGalaxyBrowserInfo(x, y, next) {
    let coord2 = x + "/" + y;
    doRequest("GET", buildRestUri("galaxy-browser-info", coord2), undefined, (res) => {
        next(res);
    });
}

export function getPlanetAbstract(x, y, z, next) {
    let coord3 = x + "/" + y + "/" + z;
    doRequest("GET", buildRestUri("planet-abstract", coord3), undefined, (res) => {
        next(res);
    });
}

export function getPlayerAbstract(id, next) {
    doRequest("GET", buildRestUri("player-abstract", id), undefined, (res) => {
        next(res);
    });
}

export function getChatOverview(next) {
    doRequest("GET", buildRestUri("chat-overview"), undefined, (res) => {
        next(res);
    });
}

export function getPlayerResearchDetails(next) {
    doRequest("GET", buildRestUri("player-research-details"), undefined, (res) => {
        next(res);
    });
}

export function getPlayerChatDetails(chat_id, next) {
    doRequest("GET", buildRestUri("chat-details", chat_id), undefined, (res) => {
        next(res);
    });
}

export function getQuests(next) {
    doRequest("GET", buildRestUri("quests"), undefined, (res) => {
        next(res);
    });
}

export function tryChatCreateRoom(participants, subject, content, next) {
    doRequest("POST", buildRestUri("chat-create-room"), {
        participants: participants,
        subject: subject,
        content: content,
    }, (res) => {
        next(res);
    });
}

export function tryChatMessage(chat_id, content, next) {
    doRequest("POST", buildRestUri("chat-message"), {
        chat_id: chat_id,
        content: content,
    }, (res) => {
        next(res);
    });
}

export function getInventory(next) {
    doRequest("GET", buildRestUri("inventory"), undefined, (res) => {
        next(res);
    });
}

export function getPlayerFleets(next) {
    doRequest("GET", buildRestUri("player-fleets"), undefined, (res) => {
        next(res);
    });
}

export function getFleetDetails(fleet_id, next) {
    doRequest("GET", buildRestUri("fleet-details", fleet_id), undefined, (res) => {
        next(res);
    });
}

export function getTwoFleetDetails(fleet_a_id, fleet_b_id, next) {
    doRequest("GET", buildRestUri("fleet-details-two", fleet_a_id + "/" + fleet_b_id), undefined, (res) => {
        next(res);
    });
}

export function tryFleetTransfer(info, next) {
    doRequest("POST", buildRestUri("fleet/transfer"), {
        info: info,
    }, next);
}

export function disbandFleet(fleet_id, next) {
    doRequest("GET", buildRestUri("fleet/disband", fleet_id), undefined, next);
}

export function getPlanetDetails(x, y, z, next) {
    let coord3 = x + "/" + y + "/" + z;
    doRequest("GET", buildRestUri("planet-details", coord3), undefined, (res) => {
        next(res);
    });
}

export function getRanking(requested_rank, next) {
    doRequest("POST", buildRestUri("ranking"), {
        requested_rank: requested_rank,
    }, (res) => {
        next(res);
    });
}

export function getShipDesigns(next) {
    doRequest("GET", buildRestUri("ship-designs"), undefined, (res) => {
        next(res);
    });
}

export function getShipDesign(ship_design_id, next) {
    doRequest("GET", buildRestUri("ship-design", ship_design_id), undefined, (res) => {
        next(res);
    });
}

export function logout(next) {
    doRequest("GET", buildRestUri("logout"), undefined, (res) => {
        next(res);
    });
}

export function tryLogin(player_name, password, next) {
    doRequest("POST", buildRestUri("login"), {
        player_name: player_name,
        password: password,
    }, (res) => {
        next(res);
    });
}

export function changePlanetName(x, y, z, name, next) {
    doRequest("POST", buildRestUri("planet/rename"), {
        x: x,
        y: y,
        z: z,
        name: name,
    }, next);
}

export function trySignUp(player_name, password, mail, faction, faction_description, next) {
    doRequest("POST", buildRestUri("sign-up"), {
        player_name: player_name,
        password: password,
        mail: mail,
        faction: faction,
        factionDescription: faction_description,
    }, (res) => {
        next(res);
    });
}

export function tryStartConstruction(x, y, z, building_id, next) {
    doRequest("POST", buildRestUri("planet/start-construction"), {
        x: x,
        y: y,
        z: z,
        building_id: building_id,
    }, next);
}

export function tryCancelConstruction(x, y, z, building_id, level, next) {
    doRequest("POST", buildRestUri("planet/cancel-construction"), {
        x: x,
        y: y,
        z: z,
        building_id: building_id,
        level: level,
    }, next);
}

export function tryStartResearch(technology_id, next) {
    doRequest("POST", buildRestUri("planet/start-research"), {
        technology_id: technology_id,
    }, next);
}

export function tryCancelResearch(event_id, next) {
    doRequest("POST", buildRestUri("planet/cancel-research"), {
        event_id: event_id,
    }, next);
}

export function tryStartShipDesign(x, y, z, ship_design, next) {
    doRequest("POST", buildRestUri("planet/start-ship-design"), {
        x: x,
        y: y,
        z: z,
        ship_design: ship_design,
    }, next);
}

export function tryQuestReply(info, next) {
    doRequest("POST", buildRestUri("quest-reply"), {
        info: info,
    }, next);
}

export function tryStartShipConstruction(x, y, z, ship_design_id, quantity, next) {
    doRequest("POST", buildRestUri("planet/start-ship-construction"), {
        x: x,
        y: y,
        z: z,
        ship_design_id: ship_design_id,
        quantity: quantity,
    }, next);
}

export function tryLaunchFleet(x, y, z, fleet_name, selected_ships, tasks, next) {
    doRequest("POST", buildRestUri("planet/launch-fleet"), {
        x: x,
        y: y,
        z: z,
        fleet_name: fleet_name,
        selected_ships: selected_ships,
        tasks: tasks,
    }, next);
}

export function trySetTaxPercentage(x, y, z, tax_percentage, next) {
    doRequest("POST", buildRestUri("planet/set-tax-percentage"), {
        x: x,
        y: y,
        z: z,
        tax_percentage: tax_percentage,
    }, next);
}

export function tryAddTaskToFleet(fleet_id, task, next) {
    doRequest("POST", buildRestUri("planet/add-task-to-fleet"), {
        fleet_id: fleet_id,
        task: task,
    }, next);
}

export function DEBUG_getGame(next) {
    doRequest("GET", buildDebugUri("game"), undefined, (res) => {
        next(res);
    });
}

export function DEBUG_runCode(code, next) {
    doRequest("POST", buildDebugUri("runCode"), {
        code: code,
    }, next);
}